const formatPhone = (values, prefix = "") => {
  let phoneNumber = values[`${prefix}phone_number`];
  // remove non-digits - not sure if this is needed after phone # validation added
  phoneNumber = phoneNumber.replace(/\D/g, "");

  if (phoneNumber) {
    values[`${prefix}area_code`] = phoneNumber.substring(0, 3);
    values[`${prefix}phone_number`] = phoneNumber.substring(3);
  }

  return values;
};

export { formatPhone };
